import { ComponentBase } from "@tblabs/truffle";


export class Paragraph extends ComponentBase<HTMLParagraphElement>
{
    constructor(text: string, klass?: string)
    {
        super("p");

        this.Class(klass);
        this.Text(text);
    }
}
